let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gWrRN")).then(() => parcelRequire('8wiEy'));